import { render } from "./Tutorial.vue?vue&type=template&id=3089a48e"
import script from "./Tutorial.vue?vue&type=script&lang=js"
export * from "./Tutorial.vue?vue&type=script&lang=js"

import "./Tutorial.vue?vue&type=style&index=0&id=3089a48e&lang=scss"
script.render = render

export default script